/*
  Site-wide scroll reveal — see assets/hs-scroll-reveal.css.

  Which sections animate:
  - HS template sections only (section key starts with hs_). Prestige's own
    sections (main-product, collection-banner, related-products...) keep the
    theme's built-in animations, so nothing animates twice.
  - Only sections that start below the fold when the page loads. The hero /
    first screen of every page type shows at once.
  - Never sections that hold fixed or sticky UI by design (sticky bars,
    drawers, popups).

  Cards inside an animated section get a staggered fade too, EXCEPT inside
  product filter / quick ship grids: those grids rebuild on every filter
  click, and re-animating the cards each time felt slow. Cards added after
  load (filter tabs, load more, pagination) are shown straight away, so a
  rebuilt grid can never be left blank.
*/
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('hs-reveal-on')) return;
  window.hsRevealReady = true;

  var CARD_SELECTOR = [
    '.hs-trust-item',
    '.style-card',
    '.hs-product-card',
    '.hs-how-it-works__step',
    '.hs-b2b-perk',
    '.hs-b2b-stat',
    '.hs-review-card'
  ].join(',');
  // Section keys (the part after "__" in the section id) that never animate
  var SKIP_SECTION = /sticky|drawer|popup|modal|announcement/;
  // Grids that rebuild on filter / page change: section fade only, no card stagger
  var NO_CARD_SECTION = /product_filter|product_with_filter|quick_ship/;
  var MAX_STAGGER_STEPS = 6;

  // Values from Theme settings > HS Scroll Animations (see the snippet)
  var config = window.hsRevealConfig || {};
  // Wait until an element is this far above the bottom of the screen, so
  // the animation plays where the visitor is looking
  var triggerPercent = typeof config.trigger === 'number' ? config.trigger : 18;
  var TRIGGER_MARGIN = '0px 0px -' + triggerPercent + '% 0px';
  // Longest animation (duration + full stagger) plus a margin
  var longest = (config.duration || 900) + (config.stagger || 150) * MAX_STAGGER_STEPS;
  var DONE_AFTER_MS = longest + 400;

  var foldLine = window.innerHeight || document.documentElement.clientHeight;

  function sectionKey(section) {
    var id = section.id || '';
    var cut = id.indexOf('__');
    return cut === -1 ? '' : id.slice(cut + 2);
  }

  function belowFold(el) {
    var rect = el.getBoundingClientRect();
    // Hidden (display: none) sections have no box; leave them alone
    if (rect.width === 0 && rect.height === 0) return false;
    return rect.top >= foldLine;
  }

  var sections = Array.prototype.filter.call(
    document.querySelectorAll('[id^="shopify-section-template--"]'),
    function (section) {
      var key = sectionKey(section);
      if (key.indexOf('hs_') !== 0) return false;
      if (SKIP_SECTION.test(key)) return false;
      if (section.querySelector('.hs-banner')) return false;
      return belowFold(section);
    }
  );

  var cards = [];
  sections.forEach(function (section) {
    section.classList.add('hs-reveal-section');
    if (NO_CARD_SECTION.test(sectionKey(section))) return;
    Array.prototype.forEach.call(section.querySelectorAll(CARD_SELECTOR), function (card) {
      card.classList.add('hs-reveal-card');
      cards.push(card);
    });
  });

  function reveal(el, index) {
    if (index !== undefined) el.style.setProperty('--hs-reveal-index', index);
    el.classList.add('hs-revealed');
    // Hand transitions and transform back to the element once it has landed
    window.setTimeout(function () {
      el.classList.add('hs-reveal-done');
      el.style.removeProperty('--hs-reveal-index');
    }, DONE_AFTER_MS);
  }

  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      sectionObserver.unobserve(entry.target);
    });
  }, { rootMargin: TRIGGER_MARGIN, threshold: 0 });

  var cardObserver = new IntersectionObserver(function (entries) {
    var step = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      reveal(entry.target, Math.min(step, MAX_STAGGER_STEPS));
      step += 1;
      cardObserver.unobserve(entry.target);
    });
  }, { rootMargin: TRIGGER_MARGIN, threshold: 0 });

  sections.forEach(function (el) { sectionObserver.observe(el); });
  cards.forEach(function (el) { cardObserver.observe(el); });

  // Jump links (the product tab menu, #reviews, any same-page anchor) work
  // out the scroll position from where a section is drawn. A section that is
  // still lowered for its fade-in would make them land 40px off, so the
  // moment such a link is clicked every pending section and card is shown
  // in place, with no animation. Runs in the capture phase, before the
  // link's own click handler measures anything.
  function finishAll() {
    sections.concat(cards).forEach(function (el) {
      if (el.classList.contains('hs-reveal-done')) return;
      el.classList.add('hs-revealed', 'hs-reveal-done');
      el.style.removeProperty('--hs-reveal-index');
    });
    sectionObserver.disconnect();
    cardObserver.disconnect();
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#' || link.pathname === window.location.pathname) finishAll();
  }, true);
  // Landed on a #hash URL: the browser has already jumped, show everything
  if (window.location.hash.length > 1) finishAll();
})();
